import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export enum AuthSearchParams {
  LoginFlow = 'loginFlow',
  LoginReason = 'loginReason',
}

export const useAuthenticationOpenState = ({
  enableParams,
}: {enableParams?: boolean} = {}) => {
  const params = enableParams
    ? [
        {
          urlSearchParam: AuthSearchParams.LoginFlow,
          allowedValues: ['login', 'register'],
        },
      ]
    : [];

  if (enableParams) {
    params.push({
      urlSearchParam: AuthSearchParams.LoginReason,
      allowedValues: ['personal-reduction', 'coupon'],
    });
  }

  const {open, ...rest} = useOpenedStateManager('AUTHENTICATED_MODAL', {
    controlParams: params,
  });

  return {
    ...rest,
    open: ({
      parameter = 'login',
      replaceHistory,
    }: {
      replaceHistory?: boolean;
      parameter?: string;
    } = {}) => open({parameter, replaceHistory}),
  };
};
